












import { Vue } from "vue-property-decorator";
import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import DailyChallenge from "./dailyChallenge/DailyChallenge.vue";
import HotApps from "./hotApps/HotApps.vue";
import { sendEvent } from "@/utils/analytics";
import * as types from "@/store/constants/types";

@Component({
  components: {
    DailyChallenge,
    HotApps,
    CasinoEntry: () => import("./casinoEntry/CasinoEntryView.vue"),
    BackUpAppRecommend: () =>
      import("@/components/backUpAppRecommend/BackUpAppRecommend.vue")
  }
})
export default class FreeCoins extends Vue {
  @Getter(types.GETTER_SETTING_DATA)
  private settingData: any;
  @Getter(types.GETTER_CASINO_ENABLED)
  private isCasinoEnabled!: boolean;
  @Getter(types.GETTER_BACK_UP_APP_SHOW_ENABLE)
  private backUpAppShow: any;

  get backUpAppShowSwitch() {
    return this.backUpAppShow;
  }

  private created() {
    //需要检查是否要显示super pay的recomend:
  }

  private mounted() {
    //页面流向
    sendEvent("page_view", "free_coins");
  }
}
